export const selectIsTemplateAsyncProcessing = (state: Record<string, any>) =>
  state.templateIndex.isTemplateAsyncProcessing;

export const selectIsFetchingMessageTypesAndSenders = (state: Record<string, any>) =>
  state.templateIndex.isFetchingMessageTypesAndSenders;
export const selectMessageTypesAndSenders = (
  state: Record<string, any>,
  { projectId, messageMedium }: Record<string, any>,
) => state.templateIndex.projects[projectId]?.[messageMedium];

export const selectPreviewThumbnails = (state: Record<string, any>) =>
  state.templateIndex?.previewThumbnails;

export const selectRootFolderId = (state: Record<string, any>) => state.templateIndex?.rootFolderId;

export const selectCopyTemplateData = (state: Record<string, any>) =>
  state.templateIndex?.copyTemplateData;
